import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import moment from "moment";
import { BlurSpinner } from "../../../components/BlurSpinner";
import useFetcher from "../../../hooks/useFetcher";
import { ButtonPrimary } from "../../../ui/buttons";
import RegistroDeVisitasModal from "./RegistroDeVisitaModal";
import { getRegistroDeVisitas } from "../../../services/clientesServices";

const RegistroDeVisitas = ({ clientId, razonSocial }) => {
  const [currentPerPage, setCurrentPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [params, setParams] = useState({ id: clientId, page: currentPage, perpage: currentPerPage });
  const [visitas, isLoadingVisitas, , , refreshVisitas] = useFetcher(getRegistroDeVisitas, [params]);
  const visitasData = visitas && visitas.rows;
  const totalRows = visitas && visitas.count;
  const [showRegistroDeVisitasModal, setShowRegistroDeVisitasModal] = useState(false);
  const [dataToEdit, setDataToEdit] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (params.page !== currentPage || params.perpage !== currentPerPage) {
      const newParams = { ...params, page: currentPage, perpage: currentPerPage };
      setParams(newParams);
    }
  }, [currentPage, currentPerPage]);

  const handleRowClicked = (row) => {
    setDataToEdit(row);
    setShowRegistroDeVisitasModal(!showRegistroDeVisitasModal);
  };

  // maneja el paginado de la tabla
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handlePerRowsChange = async (newPerPage) => {
    setLoading(true);
    setCurrentPerPage(newPerPage);

    setLoading(false);
  };

  return (
    <div style={{ fontFamily: "Nunito" }}>
      <BlurSpinner isLoading={isLoadingVisitas}>
        {showRegistroDeVisitasModal && (
          <RegistroDeVisitasModal
            toggle={() => setShowRegistroDeVisitasModal(!showRegistroDeVisitasModal)}
            isOpen={showRegistroDeVisitasModal}
            clientId={clientId}
            razonSocial={razonSocial}
            refreshVisitas={refreshVisitas}
            dataToEdit={dataToEdit}
          />
        )}

        <div className="mt-3">
          <div className="d-flex flex-row justify-content-end align-items-center mb-3">
            <ButtonPrimary
              className="btn"
              disabled={false}
              onClick={() => {
                setShowRegistroDeVisitasModal(!showRegistroDeVisitasModal);
              }}
            >
              Nuevo Registro
            </ButtonPrimary>
          </div>

          <DataTable
            data={visitasData}
            responsive
            hover
            style={{ fontFamily: "Nunito !important" }}
            onRowClicked={(row) => handleRowClicked(row)}
            noDataComponent={
              <div className="p-3">
                <b>No se cargaron Registros de Visitas</b>
              </div>
            }
            pagination
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10]}
            progressPending={loading}
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationComponentOptions={{ rowsPerPageText: "Candidatos por página", rangeSeparatorText: "de" }}
            striped
            columns={[
              {
                name: "Creación",
                selector: (row) => (row.createdAt ? moment(row.createdAt).format("DD/MM/YY") : "-"),
                id: "createdAt",
                center: true,
                width: "100px",
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                },
              },
              {
                name: "Visita",
                selector: (row) => (row.fecha ? moment(row.fecha).format("DD/MM/YY") : "-"),
                center: true,
                width: "100px",
                id: "fecha",
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                },
              },
              {
                name: "Usuario",
                selector: (row) => (row.piCreador && row.piCreador.nombreApellido ? row.piCreador.nombreApellido : "-"),
                center: true,
                wrap: true,

                id: "usuario",
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                },
              },
              {
                name: "Nombre y Apellido Cliente",
                selector: (row) => row.cliente || "-",
                center: true,
                wrap: true,

                id: "cliente",
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                },
              },
              {
                name: "Sucursal",
                selector: (row) => (row.sucursal && (row.sucursal.titulo || row.sucursal.title) ? row.sucursal.titulo || row.sucursal.title : "-"),
                center: true,
                wrap: true,

                id: "sucursal",
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                },
              },
              {
                name: "Motivo",
                selector: (row) => row.motivo || "-",
                center: true,
                wrap: true,

                id: "motivo",
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                },
              },
            ]}
          />
        </div>
      </BlurSpinner>
    </div>
  );
};
export default RegistroDeVisitas;
